<script setup lang="ts">
withDefaults(
  defineProps<{
    text: string
    variant?: keyof typeof variantMapping
  }>(),
  {
    variant: 'default'
  }
)

const variantMapping = {
  default: 'text-body',
  warning: 'text-error text-body'
}
</script>

<template>
  <p :class="variantMapping[variant]">{{ text }}</p>
</template>
